import React, { FC } from 'react';
import { RoomLaunchContainer } from './styles';
import { LaunchedState } from './LaunchedState';
import { VIRTUAL_SPACE_TAG_ID, PLATFORMS } from './constants';
import { useGetProjectPackages } from './useGetProjectPackages';

interface RoomLaunchBlockViewProps {
  className?: string;
  selectedTags?: string[];
  projectId?: string;
}

export const RoomLaunchBlockView: FC<RoomLaunchBlockViewProps> = ({ 
  className, 
  selectedTags = [], 
  projectId
}) => {
  const isVirtualSpaceSelected = selectedTags.includes(VIRTUAL_SPACE_TAG_ID);
  const { downloadRoomUrls, isLoading } = useGetProjectPackages(projectId, isVirtualSpaceSelected);

  if (!isVirtualSpaceSelected) {
    return null;
  }

  if (isLoading || downloadRoomUrls.length === 0) {
    return null;
  }

  const uploadedPlatforms = downloadRoomUrls
    .filter(item => item.platform !== 0)
    .map(item => {
      const platform = PLATFORMS.find(p => p.platformType === getPlatformName(item.platform));
      return platform?.label || getPlatformName(item.platform);
    });

  return (
    <RoomLaunchContainer className={className}>
      <LaunchedState
        projectId={projectId}
        uploadedPlatforms={uploadedPlatforms}
        showEditButton={false}
      />
    </RoomLaunchContainer>
  );
};

const getPlatformName = (platformType: number): string => {
  const platformMap: { [key: number]: string } = {
    0: 'Unity',
    1: 'Windows',
    2: 'MacOS',
    3: 'Android',
  };
  return platformMap[platformType] || 'Unknown';
};

import React, { FC } from 'react';
import { RoomLaunchContainer } from './styles';
import { LaunchedState } from './LaunchedState';
import { VIRTUAL_SPACE_TAG_ID, PLATFORMS } from './constants';
import { useGetProjectPackages } from './useGetProjectPackages';

interface RoomLaunchBlockViewProps {
  className?: string;
  selectedTags?: string[];
  projectId?: string;
}

export const RoomLaunchBlockView: FC<RoomLaunchBlockViewProps> = ({ 
  className, 
  selectedTags = [], 
  projectId
}) => {
  const isVirtualSpaceSelected = selectedTags.includes(VIRTUAL_SPACE_TAG_ID);
  const { downloadRoomUrls, isLoading } = useGetProjectPackages(projectId, isVirtualSpaceSelected);

  if (!isVirtualSpaceSelected) {
    return null;
  }

  if (isLoading || downloadRoomUrls.length === 0) {
    return null;
  }

  const uploadedPlatforms = downloadRoomUrls
    .filter(item => item.platform !== 0)
    .map(item => {
      const platform = PLATFORMS.find(p => p.platformType === getPlatformName(item.platform));
      return platform?.label || getPlatformName(item.platform);
    });

  return (
    <RoomLaunchContainer className={className}>
      <LaunchedState
        projectId={projectId}
        uploadedPlatforms={uploadedPlatforms}
        showEditButton={false}
      />
    </RoomLaunchContainer>
  );
};

const getPlatformName = (platformType: number): string => {
  const platformMap: { [key: number]: string } = {
    0: 'Unity',
    1: 'Windows',
    2: 'MacOS',
    3: 'Android',
  };
  return platformMap[platformType] || 'Unknown';
};

